import { useMemo } from "react";
import { useStore } from "@/stores/useStore";
import { layout as layoutRepository } from "@/repositories/layout";
import { Card } from "@/types/v2";

export interface SearchResultRow {
  card: Card;
  containerName: string;
  layoutNames: string[];
}

export const useSearchResults = (cards: Card[]): SearchResultRow[] => {
  const shop = useStore((s) => s.shop);

  return useMemo(() => {
    if (!shop) return [];

    return cards.map((card) => {
      const container = shop.containers.find(
        (c) => c.id === card.currentContainer
      );
      const layoutNames = layoutRepository
        .findLayoutsWithContainer(card.currentContainer, shop.layouts)
        .map((layoutEntry) => Object.keys(layoutEntry)[0]);

      return {
        card,
        // Intentionally falls back to the raw container id rather than
        // getContainerName()'s "Unknown Container" — a missing container id
        // here is more useful to a searcher as a literal, searchable value.
        containerName:
          container?.displayName ?? card.currentContainer ?? "Unknown",
        layoutNames,
      };
    });
  }, [cards, shop]);
};
